import baseUrl from "../config/baseUrl";

const loginUser = async (email, name, id, phone) => {
  try {
    const response = await fetch(`${baseUrl}/api/login_users`, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: new URLSearchParams({
        email: email,
        name,
        phone,
        id,
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default loginUser;
